import { render, staticRenderFns } from "./BrandThumbnailsCarousel.vue?vue&type=template&id=5f60a4ce&scoped=true&"
import script from "./BrandThumbnailsCarousel.vue?vue&type=script&lang=ts&"
export * from "./BrandThumbnailsCarousel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f60a4ce",
  null
  
)

export default component.exports